module.exports = __webpack_public_path__ + "images/banner-guangdong.jpg?ea48af56dc429fe1879824838937f9c3";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-guangdong.jpg
// module id = 170
// module chunks = 1